import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/client';

/**
 * SUNUCU DURUMU SAĞLAYICISI.
 *
 * TEKRAR DENEME POLİTİKASI: 4xx hataları TEKRAR DENENMEZ. 403 veya 404
 * alan bir istek üç kez daha denendiğinde sonuç değişmez; yalnızca
 * kullanıcı üç kat daha uzun bekler ve sunucu gereksiz yük alır.
 * Yalnızca ağ hataları ve 5xx tekrarlanır.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  // `useState` ile: sıcak yeniden yükleme (HMR) sırasında istemci
  // yeniden oluşturulmaz, önbellek korunur.
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: (failureCount, error) => {
              if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
                return false;
              }
              return failureCount < 2;
            },
            // Sekmeye her dönüşte istek atmak, uzun süre açık kalan
            // panolarda gereksiz yük üretir; veri zaten `staleTime`
            // dolduğunda tazelenir.
            refetchOnWindowFocus: false,
          },
          mutations: {
            // Yazma işlemleri ASLA otomatik tekrarlanmaz: başarısız
            // sanılan bir istek aslında sunucuya ulaşmış olabilir ve
            // tekrar denemek çift kayıt üretir.
            retry: false,
          },
        },
      }),
  );

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
